import { API_URLS } from "../../constants/apiUrls";
import { commonFetch } from "../commonFetch";

export const InsertSchoolProfile = async (formData) => {
  return commonFetch("SchoolDashboard/insert/SchoolProfile", {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
};

export const UpdateSchoolProfile = async (id,formData) => {
  return commonFetch(`SchoolDashboard/UpdateSchoolProfileById?id=${id}`, {
    method: "PUT",
    body: formData,
    requiresAuth: true,
  });
};

export const getAllAdminsSchools = async (adminID) => {
   return commonFetch(`${API_URLS.GET_ACTIVE_ADMIN_SCHOOLS}/${adminID}`, {
    method: "GET",
    requiresAuth: true,
  });
};

export const getSchoolByID = async (schoolID) => {
   return commonFetch(`SchoolDashboard/GetSchoolProfileById?SchoolID=${schoolID}`, {
    method: "GET",
    requiresAuth: true,
    headers: {
      accept: "*/*",
    },
  });
};

export const GetAdminprofile = async (AdminID,schoolID) => {
   return commonFetch(`${API_URLS.ADMIN_PROFILE}?AdminID=${AdminID}&SchoolID=${schoolID}`, {
    method: "GET",
    requiresAuth: true,
    headers: {
      accept: "*/*",
    },
  });
};

export const UpdateAdminProfileData = async (formData) => {
  return commonFetch(`${API_URLS.UPDATE_ADMIN_PROFILE}`, {
    method: "PUT",
    body: formData,
    requiresAuth: true,
  });
};


export const BulkUploadStudentRegistration = async (formData) => {
  return commonFetch(`${API_URLS.BULK_UPLOAD_STUDENT_REGISTRATION}`, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
};



export const BulkUploadEmployeeRegistration = async (formData) => {
  return commonFetch(`${API_URLS.BULK_UPLOAD_EMPLOYEE_REGISTRATION}`, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
};

export const BulkUploadStudentAttendance = async (formData) => {
  return commonFetch(`${API_URLS.BULK_UPLOAD_STUDENT_ATTENDANCE}`, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
};

export const BulkUploadEmployeeAttendance = async (formData) => {
  return commonFetch(`${API_URLS.BULK_UPLOAD_EMPLOYEE_ATTENDANCE}`, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
};

//Download

export const StudentBulkExcelSheetDownload = async (formBody) => {
  return commonFetch(`${API_URLS.BULK_EXCEL_SHEET_STUDENT_DOWNLOAD}`, {
    method: "POST",
    body: formBody,
    requiresAuth: true,
  });
};

export const EmployeeBulkExcelSheetDownload = async (formBody) => {
  return commonFetch(`${API_URLS.BULK_EXCEL_SHEET_EMPLOYEE_DOWNLOAD}`, {
    method: "POST",
    body: formBody,
    requiresAuth: true,
  });
};

export const StudentAttendanceBulkExcelSheetDownload = async (formBody) => {
  return commonFetch(`${API_URLS.BULK_EXCEL_SHEET_STUDENT_ATTENDANCE_DOWNLOAD}`, {
    method: "POST",
    body: formBody,
    requiresAuth: true,
  });
};

export const EmployeeAttendanceBulkExcelSheetDownload = async (formBody) => {
  return commonFetch(`${API_URLS.BULK_EXCEL_SHEET_EMPLOYEE_ATTENDANCE_DOWNLOAD}`, {
    method: "POST",
    body: formBody,
    requiresAuth: true,
  });
};

export const UpdateBulkUserIdentity = async (formData) => {
  return commonFetch(`${API_URLS.UPDATE_BULK_STUDENT_IDENTITY}`, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
};

export const CreateWhatsAppSetting = async (formData) =>
  commonFetch(API_URLS.CREATE_WHATSAPP_SETTING, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });

//   export const UpdateSchoolQrCodeBySchoolID = async (id,formData) => {
//   return commonFetch(`${API_URLS.UPDATE_SCHOOL_QRCODE_BY_SCHOOLID}?id=${id}`, {
//     method: "PUT",
//     body: formData,
//     requiresAuth: true,
//   });
// };
export const UpdateSchoolQrCodeBySchoolID = async (formData) => {
  return commonFetch(API_URLS.UPDATE_SCHOOL_QRCODE_BY_SCHOOLID, {
    method: "PUT",
    body: formData,
    requiresAuth: true,
  });
};
  export const DeleteSchoolQrCodeBySchoolID = async (SchoolID) => {
  return commonFetch(`${API_URLS.DELETE_SCHOOL_QRCODE_BY_SCHOOLID}?SchoolID=${SchoolID}`, {
    method: "DELETE",
    requiresAuth: true,
  });
};

export const AdminPasswordchange = async (payload) => {
  return commonFetch(`${API_URLS.ADMIN_CHANGE_PASSWORD}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const EmployeePasswordchange = async (payload) => {
  return commonFetch(`${API_URLS.EMPLOYEE_CHANGE_PASSWORD}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const ParentPasswordchange = async (payload) => {
  return commonFetch(`${API_URLS.PARENT_CHANGE_PASSWORD}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const StudentPasswordchange = async (payload) => {
  return commonFetch(`${API_URLS.STUDENT_CHANGE_PASSWORD_WITH_OTP}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const UploadMultiFilesOfSchool = async (formData) => {
  return commonFetch(API_URLS.UPLOAD_SCHOOL_MULTIFILES, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
};

export const GetAllAcademicYearList = async (formData) => {
  return commonFetch(`${API_URLS.GETALL_SCHOOL_ACADEMICYEAR}`, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
};

export const UpdateStudentStatusClass = async (formData) => {
  return commonFetch(`${API_URLS.UPDATE_STUDENT_STATUS_CLASS}`, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
};

export const GetActiveStudentsByClasses = async (formData) => {
  return commonFetch(`${API_URLS.GET_ACTIVE_STUDENTS_BY_CLASSES}`, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
};



export const GetUserInfoManageLogin = async (payload) => {
  return commonFetch(`${API_URLS.GET_ALL_USERINFO_AND_ROLES}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const InsertUpdateManagelogin = async (payload) => {
  return commonFetch(`${API_URLS.INSERT_UPDATE_USERINFO_ROLES}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const GetStudentFeeDecisionStudent = async (payload) => {
  return commonFetch(`${API_URLS.GET_ALL_USERINFO_FEE_DECISION_STUDENT}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const SaveStudentFeeDecisionStudent = async (payload) => {
  return commonFetch(`${API_URLS.INSERT_UPDATE_FEE_DECISION_STUDENT}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const GetStudentFeeScheduleCollectionStatus = async (payload) => {
  return commonFetch(`${API_URLS.GET_FEE_COLLECTED_SHCEDULE_STATUS}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};